<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <MenuCard :menuItems="menuItems" />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import MenuCard from "@/components/MenuCard";

export default {
    page: {
        title: i18n.t("module.property"),
    },
    components: { Layout, PageHeader, MenuCard },
    data() {
        return {
            title: i18n.t("module.property"),
            items: [
                {
                    text: i18n.t("module.property"),
                    active: true,
                },
            ],
            menuItems: [
                {
                    route: 'PropertyAsset',
                    label: i18n.t('label.asset'),
                    icon: 'mdi-home-outline',
                    color: 'info',
                    core: true,
                },
                {
                    route: 'PropertyTenanted',
                    label: i18n.t('label.tenanted'),
                    icon: 'mdi-home-account',
                    color: 'success',
                    core: true,
                },
                {
                    route: 'PropertyAssetRental',
                    label: i18n.t('label.assetRental'),
                    icon: 'mdi-cash-multiple',
                    color: 'primary',
                    core: true,
                },
                {
                    route: 'PropertyStatus',
                    label: i18n.t('module.propertyStatus'),
                    icon: 'mdi-checkbox-marked-circle-outline',
                    color: 'primary',
                    core: false,
                },
                {
                    route: 'PropertyAction',
                    label: i18n.t('module.propertyAction'),
                    icon: 'mdi-cursor-pointer',
                    color: 'info',
                    core: false,
                },
                {
                    route: 'PropertyAreaUnit',
                    label: i18n.t('module.propertyAreaUnit'),
                    icon: 'mdi-ruler-square',
                    color: 'success',
                    core: false,
                },
                {
                    route: 'PropertyCategory',
                    label: i18n.t('module.propertyCategory'),
                    icon: 'mdi-shape-outline',
                    color: 'warning',
                    core: false,
                },
                {
                    route: 'PropertyTenure',
                    label: i18n.t('module.propertyTenure'),
                    icon: 'mdi-file-document-outline',
                    color: 'secondary',
                    core: false,
                },
                {
                    route: 'PropertyType',
                    label: i18n.t('module.propertyType'),
                    icon: 'mdi-home-city-outline',
                    color: 'danger',
                    core: false,
                },
            ],
        };
    },
}
</script>